import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

import { defaultSettings } from "./RecordTableSettings";
import RecordTableContent from "./RecordTableContent";
import withQueryWidget, { WithQueryWidgetProps } from "components/widgetParts/queryWidgetComposition/withQueryWidget";
import { getSingleWidgetResponseByName } from "system/widget/Widget";
import useAuth from "system/APIAuth";
import APIRequest from "system/APIRequest";
import { useSnackbar } from "notistack";
import { useTranslation } from 'react-i18next'

export interface RecordTableWidgetData {
  records: Array<any>;
  fieldLabels: Object;
  fieldValues: Object;
  autoPageSize?: boolean;
}

function RecordTableWidget(props: WithQueryWidgetProps): JSX.Element {
  const { i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const auth = useAuth();

  const apiResponseInfo = getSingleWidgetResponseByName(props.apiResponses, 'record-table');
  const apiResponse = apiResponseInfo?.responseBody;

  const recordTableData = props.widget?.data as RecordTableWidgetData;
  const columnModel = props.widget?.data?.columnModel;

  const settings = {
    ...defaultSettings,
    ...props?.widget?.data,
    ...props.widget?.data?.settings,
  };

  const [cursor, setCursor] = useState<string | null>( null);
  const [records, setRecords] = useState<any[]>([]);

  const fetchMoreRecords = () => {
    const requestInfo = apiResponseInfo?.originatingRequest?.requestInit?.body || {};
    const newRequestInfo = { ...requestInfo };

    newRequestInfo.records.cursor = cursor;

    APIRequest(`query/records/${apiResponseInfo?.originatingRequest?.activeQueryIds?.join(",") || ""}`,  {}, {
      method: "POST",
      body: JSON.stringify(newRequestInfo)
    }).then((response) => {
      if (response) {
        setRecords([...records, ...response.records]);
        setCursor(response.cursor || null);
      }
    }).catch((error) => {
      enqueueSnackbar(i18n.t("widget-types.embed-list.alerts.fetch-error", {errorMessage: error}), { variant: "error" });
    });
  }

  // Set the initial Records
  useEffect(() => {
      setRecords([ ...records, ...apiResponse.records ]);
      setCursor(apiResponse.cursor || null);
  }, [apiResponse]);

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <RecordTableContent
        apiResponse={apiResponse}
        records={records}
        columnModel={columnModel}
        currentState={settings}
        recordTableData={recordTableData}
        widgetQueryTitle={apiResponseInfo?.queryDisplayTitle}
        onFetchMore={auth.user ? fetchMoreRecords : undefined}
      />
    </Box>
  );
}

export default withQueryWidget(RecordTableWidget, {
    hasSettingsDialog: true,
    hasQueryDialog: true,
    exportOptions: ["50", "100", "250", "500", "1000", "2500", "5000", "10000"]
})
